function getAddress(dispatchableAddress = {}) {
    const {borough = "", stateOrProvince = "", country = ""} = dispatchableAddress;
    let address = "";
    if (borough) {
        address += borough + ", ";
    }
    if (stateOrProvince) {
        address += stateOrProvince + ", ";
    }
    if (country) {
        address += country;
    }

    return address || "No Resolved Location";
}

const Call = ({phoneNumber, sourceIdentifier1, created, callUuid, eml, isSelected = false, onSelect = () => {}}) => {
    const parsedDate = new Date(Date.parse(created));
    const formattedTime = parsedDate.toLocaleTimeString([], {hour: "numeric", minute: "2-digit"});
    const phone = phoneNumber || sourceIdentifier1 || "Phone No. Not Available";
    const emlLocations = eml?.[0]?.payload?.[0]?.rankedLocations ? [...eml[0].payload[0].rankedLocations] : [];
    emlLocations.sort((left, right) => left.confidence > right.confidence ? -1 : 1);
    const topEmlLocation = emlLocations.length ? emlLocations[0] : {dispatchableAddress: {}};
    const {dispatchableAddress = {}} = topEmlLocation;

    return <button
        onClick={onSelect}
        className={`w-full rounded-2xl border p-5 text-left transition ${
            isSelected
                ? "border-blue-500 bg-blue-50 shadow-sm"
                : "border-slate-200 bg-white hover:border-slate-300"
        }`}
    >
        <div className="flex items-start justify-between gap-3">
            <div>
                <div className="text-lg font-semibold text-slate-700">{phone}</div>
                <div className="mt-1 text-sm text-slate-500">{formattedTime} {parsedDate.toDateString()}</div>
            </div>
        </div>
        <div className="mt-4 text-sm font-medium text-blue-800">{getAddress(dispatchableAddress)}</div>
        <div className="mt-3 break-all text-xs text-slate-400">{callUuid}</div>
    </button>;
};

export default Call;
